import { defineStore } from 'pinia'

/**
 * Pinia 버전 토큰 스토어
 * - Vuex tokenModule과 동일한 상태/액션을 유지하여 점진 전환
 */
const loadStoredToken = () => {
  try {
    const raw = window.localStorage.getItem('pinia_token')
    if (!raw) return { accessToken: null, refreshToken: null, refreshTime: null }
    const parsed = JSON.parse(raw)
    return {
      accessToken: parsed.accessToken || null,
      refreshToken: parsed.refreshToken || null,
      refreshTime: parsed.refreshTime || null,
    }
  } catch (error) {
    return { accessToken: null, refreshToken: null, refreshTime: null }
  }
}

const persistToken = (payload) => {
  try {
    window.localStorage.setItem('pinia_token', JSON.stringify(payload))
  } catch (error) {}
}

const clearStoredToken = () => {
  try {
    window.localStorage.removeItem('pinia_token')
  } catch (error) {}
}

export const useTokenStore = defineStore('token', {
  state: () => ({
    /** @type {{ accessToken: string|null, refreshToken: string|null, refreshTime: number|null }} */
    ...loadStoredToken(),
  }),
  actions: {
    /**
     * @param {import('@/types/token').TokenPayload} payload
     */
    setToken(payload) {
      this.accessToken = payload.accessToken || null
      this.refreshToken = payload.refreshToken || null
      this.refreshTime = new Date().getTime()
      persistToken({
        accessToken: this.accessToken,
        refreshToken: this.refreshToken,
        refreshTime: this.refreshTime,
      })
    },
    /**
     * @param {string|null} token
     */
    setAccessToken(token) {
      this.accessToken = token || null
      persistToken({
        accessToken: this.accessToken,
        refreshToken: this.refreshToken,
        refreshTime: this.refreshTime,
      })
    },
    removeToken() {
      this.accessToken = null
      this.refreshToken = null
      this.refreshTime = null
      clearStoredToken()
    },
  },
})

export default useTokenStore
